// API configuration for PHP backend on Hostinger
export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_URL || 'http://localhost:8000/api',
  TIMEOUT: 10000, // 10 seconds
  RETRY_ATTEMPTS: 3,
};

// Backend endpoints
export const API_ENDPOINTS = {
  BOOKINGS: '/bookings',
  BOOKING_BY_ID: (id: string) => `/bookings/${id}`,
  BOOKING_STATUS: (id: string) => `/bookings/${id}/status`,
  BOOKING_APPROVE: (id: string) => `/bookings/${id}/approve`,
  BOOKING_REJECT: (id: string) => `/bookings/${id}/reject`,
  BOOKING_CONFIRM: (id: string) => `/bookings/${id}/confirm`,
  ADMIN_BOOKINGS: '/admin/bookings',
  ADMIN_PENDING: '/admin/bookings/pending',
};